
import {Gui} from './gui.js';
import './style.css';

// setup
const gui = new Gui();
gui.setup();
gui.onDOMContentLoaded();